import React from "react";

export type PlaybackControlButtonProps =
  React.ButtonHTMLAttributes<HTMLButtonElement> & {
    icon?: React.ReactNode;
    endIcon?: React.ReactNode;
    suffix?: React.ReactNode;
  };

export type PlaybackControlClusterProps = {
  ariaLabel: string;
  className?: string;
  children: React.ReactNode;
};

export const PlaybackControlButton = React.forwardRef<
  HTMLButtonElement,
  PlaybackControlButtonProps
>(function PlaybackControlButton(
  {
    icon,
    endIcon,
    suffix,
    className,
    children,
    type = "button",
    ...buttonProps
  },
  ref,
) {
  const buttonClassName = className
    ? `eeg-playback-control ${className}`
    : "eeg-playback-control";

  return (
    <button {...buttonProps} ref={ref} type={type} className={buttonClassName}>
      {icon ? (
        <span className="eeg-playback-control__icon" aria-hidden="true">
          {icon}
        </span>
      ) : null}
      {children !== undefined && children !== null ? (
        <span className="eeg-playback-control__label">{children}</span>
      ) : null}
      {suffix ?? null}
      {endIcon ? (
        <span
          className="eeg-playback-control__icon eeg-playback-control__icon--end"
          aria-hidden="true"
        >
          {endIcon}
        </span>
      ) : null}
    </button>
  );
});

PlaybackControlButton.displayName = "PlaybackControlButton";

export function PlaybackControlCluster({
  ariaLabel,
  className,
  children,
}: PlaybackControlClusterProps) {
  return (
    <div
      className={
        className ? `eeg-playback-cluster ${className}` : "eeg-playback-cluster"
      }
      role="group"
      aria-label={ariaLabel}
    >
      {children}
    </div>
  );
}
